import data from '../assets/image/export.image';

export default function getObjectByKey(key: any): string {
  if (typeof key !== 'string') {
    return '';
  }

  const upperCaseKey = key.toUpperCase();

  if (data.hasOwnProperty(upperCaseKey)) {
    return data[upperCaseKey];
  }

  return '';
}
